<template lang="pug">
#visualizar-processamento-contrato
    BaseHeader(
        titulo='Visualizar contrato',
        :exibeBotao='!foiConcluido',
        :tooltip='tooltipConcluir',
        btnTexto='Concluir contrato',
        icon='el-icon-check',
        :voltarPara='true',
        :desabilitaBotao='!botaoConcluirHabilitado',
        @btnHeaderClicado='concluirProcessamento'
    )

    .view-container.alinhar-conteudo.margen-bottom-pages
        section
            BlocoDadosContratoOriginacao(:dados='dados')

        section
            Resumo(:resumo='resumo')

        section
            Tabela(
                :podeRemoverTerritorio='!foiConcluido',
                :numeroContrato='numeroContrato',
                @territorio-removido='buscarInformacoesContrato',
                @visualizar='visualizarDiagnosticoTerritorio'
            )

    ModalDetalheAnalise(ref='refModalDetalheAnalise')
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoDadosContratoOriginacao from '@/components/contratosOriginacao/BlocoDadosContratoOriginacao';
import Resumo from '@/components/contrato/BlocoResumoContratoOriginacao';
import Tabela from '@/components/contrato/TabelaVisualizarProcessamentoContratoSubEmpresa';

import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ModalDetalheAnalise from '@/components/contratosOriginacao/ModalDetalheAnalise.vue';

export default {
    name: 'VisualizarProcessamentoContrato',
    components: {
        ModalDetalheAnalise,
        BaseHeader,
        BlocoDadosContratoOriginacao,
        Resumo,
        Tabela
    },

    data() {
        return {
            numeroContrato: this.$route.params.numeroContrato,
            dados: {},
            resumo: {},
            botaoConcluirHabilitado: false,
            tooltipConcluir: null,
            foiConcluido: false
        };
    },

    mounted() {
        this.buscarInformacoesContrato();
    },

    methods: {
        visualizarDiagnosticoTerritorio(item) {
            try {
                ContratoOriginacaoService.buscarDetalheAnalise(
                    this.$route.params.numeroContrato,
                    item.idTerritorio
                )
                    .then(({ data }) => {
                        const { territorio, pessoas } = data;
                        const diagnostico = {
                            grupo: [
                                {
                                    nome: territorio.nome,
                                    titulo: 'Área Analisada',
                                    diagnostico: territorio.diagnostico
                                }
                            ],
                            territorioGeometria: territorio.geometria
                        };

                        if (pessoas) {
                            pessoas.forEach(pessoa => {
                                diagnostico.grupo.push({
                                    nome:
                                        pessoa.nomePessoa +
                                        ' | ' +
                                        pessoa.cpfCnpj,
                                    titulo: 'Pessoa Analisada',
                                    diagnostico: pessoa.diagnostico
                                });
                            });
                        }

                        this.$refs.refModalDetalheAnalise.abrirModal(
                            diagnostico
                        );
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: error.response.data.message
                        });
                    });
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de visualizar diagnostico de territorio.'
                });
            }
        },

        async buscarInformacoesContrato() {
            try {
                const { data } =
                    await ContratoOriginacaoService.buscarVisualizarProcessamentoSubEmpresa(
                        { numeroContrato: this.numeroContrato }
                    );

                const {
                    numeroContrato,
                    culturaNome,
                    safraNome,
                    volumeContratado,
                    dataContrato,
                    volumeInserido,
                    volumeComRestricoes,
                    saldo,
                    territoriosInseridos,
                    territoriosConformes,
                    territoriosInConformes,
                    statusSubEmpresaCodigo,
                    statusSubEmpresa
                } = data;

                this.dados = {
                    numeroContrato,
                    culturaNome,
                    safraNome,
                    volumeContratado,
                    dataContrato,
                    statusSubEmpresaCodigo,
                    statusSubEmpresa
                };

                this.resumo = {
                    volumeContratado,
                    volumeInserido,
                    volumeComRestricoes,
                    saldo,
                    territoriosInseridos,
                    territoriosConformes,
                    territoriosInConformes,
                    territoriosAlerta: '--'
                };

                this.foiConcluido = statusSubEmpresaCodigo === 'CONCLUIDO';

                this.verificaConcluir();
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar informações de contrato.'
                });
            }
        },

        async concluirProcessamento() {
            try {
                await ContratoOriginacaoService.concluirProcessamentoContratoSubempresa(
                    { contrato: this.numeroContrato }
                );

                this.$router.push({ name: 'RastreabilidadeSubEmpresa' });
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível concluir o processamento.'
                });
            }
        },

        async verificaConcluir() {
            try {
                const { data } =
                    await ContratoOriginacaoService.verificaConcluir(
                        this.$route.params.numeroContrato
                    );
                this.botaoConcluirHabilitado = data;
                this.tooltipConcluir =
                    'O volume total enviado é diferente do volume total informado ou existem territórios com restrições. Para concluir deve ser resolvido essas inconsistências.';
                if (this.botaoConcluirHabilitado) {
                    this.tooltipConcluir = null;
                }
                if (this.foiConcluido) {
                    this.botaoConcluirHabilitado = false;
                }
            } catch (error) {
                this.$notify.error({
                    message:
                        'Não foi possível verificar se o contrato foi concluído.'
                });
            }
        }
    }
};
</script>

<style lang="scss">
#visualizar-processamento-contrato {
    .alinhar-conteudo {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 16px;
    }
}
</style>
